import { useContext } from "react";

import { WebworkerContext } from "./WebworkerContext";

export function useWebworker() {
  const webWorkerValue = useContext(WebworkerContext);
  if (!webWorkerValue) {
    throw new Error("WebworkerContext is not found.");
  }
  const { workerRef, progress, setProgress } = webWorkerValue;

  function initWorker(worker: Worker) {
    worker.onerror = (e) => {
      console.error("worker error");
      console.error(e);
    };

    workerRef.current = worker;
  }

  function cleanupWorker() {
    workerRef.current?.terminate();
    workerRef.current = null;
  }

  function postMessage(message: any) {
    if (!workerRef.current) {
      throw new Error("WebWorker is not initialized");
    }
    workerRef.current.postMessage(message);
  }

  function onMessage(callback: (_e: MessageEvent) => void) {
    if (!workerRef.current) {
      throw new Error("Worker is not initialized");
    }
    workerRef.current.onmessage = callback;
  }

  return {
    initWorker,
    cleanupWorker,
    postMessage,
    onMessage,
    progress,
    setProgress,
  };
}
